/**
 * Downloads a course PDF with session cookies so the authenticated file proxy works.
 *
 * @param {string} viewUrl
 * @returns {Promise<ArrayBuffer>}
 */
export async function fetchPdfArrayBuffer(viewUrl) {
  const response = await fetch(viewUrl, { credentials: "include" });
  if (!response.ok) {
    throw new Error("pdf fetch failed");
  }
  return response.arrayBuffer();
}
